module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('big', [_c('span', {
    staticClass: "small"
  }, [_vm._v("T")])]), _vm._v("his book is dedicated to every warrior who has stepped into harm’s way, put his life at risk, and has allowed our nation to survive against what sometimes seemed impossible or overwhelming odds on countless fields of battle.")], 1), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The warriors who fought with me in Vietnam, including the boat support crews, navy pilots, army helicopter pilots, and, never last or least, my brother SEALs, have all added their personal history to a warrior tradition. No list of names is needed here, they know who they are and the honor they have given me by allowing me to earn their trust and respect. Hoo-Yah!")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725840fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 69
// module chunks = 0